import axios from 'axios';
import { authService } from './authService';
const getToken = () => {
    const user = authService.user();
    return user?.token || '';
};

export const httpRequest = axios.create();

httpRequest.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
});

httpRequest.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('_viveka_temp');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);
//     console.log("httpUser",user);
//     if(user){
//         return user?.token || '';
//     }
//     return '';
// }
// export const httpRequest = axios.create({
//     headers: {
//         Authorization: 'Bearer ' + getToken()
//     },
// });
